import { Column, Grid, Row, Spacing, Text } from '@dls/web';
import { CONFIGS } from '../../config/common';
import {
  getAccessoryMTPOSStockCache,
  getAccessoryOnlineStock
} from '../../helpers/accessory';
import { accessoryRibbon } from '../Accessory/AccessoryRibbon';
import { trans as t } from '../../helpers/localisation';
import React from 'react';
import { useAccessories } from '../../hooks/useAccessory';
import { useSelector } from 'react-redux';
import { BaseState } from '../../types/state.types';
import { Accessory } from '../../types/accessory.types';
import { Accessories } from '@common-modules/product-catalogue';
import { StockAvailability } from '../../types/product.types';
type PropTypes = {
  accessories: Accessory[];
  isMTPOSStockCacheEnabled: boolean;
  abTestingPending: boolean;
  handleAddAccessory: (accessory: Accessory) => void;
  handleRemoveAccessories: (
    accessory: Accessory,
    isRemoveFromList: boolean
  ) => void;
  enableAccessoriesForShoppingCart: string;
  isLoading: boolean;
  accessoryAvailability: StockAvailability[];
};
export const ShoppingCartAccessories = (props: PropTypes) => {
  const {
    accessories,
    isMTPOSStockCacheEnabled,
    handleAddAccessory,
    handleRemoveAccessories,
    enableAccessoriesForShoppingCart,
    isLoading,
    accessoryAvailability
  } = props;
  const { user, product, accessory, cart } = useSelector<
    BaseState,
    Partial<BaseState>
  >(state => state);
  const { selectedProduct } = product;
  const { cartOrder } = cart;
  const { formattedAccessories } = useAccessories({
    accessories,
    recommendedAccessories: selectedProduct?.recommendedAccessories ?? [],
    stockAvailability: accessoryAvailability
  });

  const renderAccessories = () => {
    if (
      enableAccessoriesForShoppingCart !== 'true' ||
      !selectedProduct ||
      selectedProduct?.isBackOrder ||
      formattedAccessories === undefined ||
      isLoading
    )
      return null;

    const isCis = !!user?.cis?.information?.rates;

    return (
      <Spacing top={1} responsive={false}>
        <Accessories
          configs={{
            maxNumberOfAccessories: CONFIGS.ACCESSORIES_LIMIT,
            isLoading: isLoading,
            baseUrl: window.location.origin,
            pagination: 2
          }}
          callbacks={{
            onAdd: accessory => {
              handleAddAccessory(accessory);
            },
            onRemove: accessory => {
              handleRemoveAccessories(accessory, true);
            },
            checkStock: isMTPOSStockCacheEnabled
              ? getAccessoryMTPOSStockCache
              : getAccessoryOnlineStock
          }}
          accessoryRibbon={accessoryRibbon(isCis)}
          data={{
            accessories: formattedAccessories,
            deviceTitle: selectedProduct.title
          }}
          localisation={{
            ACCESSORY_HEADER_TEXT: t('ACCESSORIES_TITLE')
          }}
          preselectAccessories={accessory?.selectedAccessories?.map(
            accessory => accessory.id
          )}
        />
      </Spacing>
    );
  };

  const renderNote = () => {
    if (formattedAccessories === undefined || isLoading) return null;
    const firstBillNote = cartOrder?.firstBills?.length ? (
      <Text>{t('SHOPPING_CART_FIRST_BILL_NOTE')}</Text>
    ) : null;
    return (
      <Spacing>
        {firstBillNote && <Text type="body">{firstBillNote}</Text>}
        <Spacing top={2}>
          <Text type={'body'}>{t('CALL_BARRING_SERVICE_MSG')}</Text>
        </Spacing>
      </Spacing>
    );
  };

  return (
    <Grid id="accessory-section">
      <Row noGutter>
        <Column noGutter xs={12}>
          {renderAccessories()}
        </Column>
      </Row>
      <Row>
        <Column noGutter xs={12}>
          {renderNote()}
        </Column>
      </Row>
    </Grid>
  );
};
